"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArrow = function IconArrow(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement(Svg, {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M 0.999687 7 L 13.000312 7 ",
    transform: "matrix(3.571429,0,0,3.571429,0,0)",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M 7 0.999687 L 13.000312 7 L 7 13.000312 ",
    transform: "matrix(3.571429,0,0,3.571429,0,0)",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var Svg = _styledComponents.default.svg.withConfig({
  displayName: "Svg"
})(["padding:0.5rem;"]);

IconArrow.defaultProps = {
  color: 'black',
  size: 30
};
IconArrow.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconArrow;
exports.default = _default;